import React from "react";
import { Link } from "react-router-dom";

const Relaxation5 = () => {
  return (
    <section className="bg-[#F5F5F5] h-screen shadow-[0_3px_10px_rgb(0,0,0,0.2)] m-4 rounded-md col-span-4">
      <div className="h-full px-3 py-4 overflow-y-auto">
        <div>
          <p className="text-[#314C1C] text-2xl px-4 pb-3 font-crimson-pro font-bold">
            RELAXATION
          </p>
          <p className="text-[#314C1C] text-lg px-4 font-semibold">
            INSTRUCTIONS
          </p>
          <p className="text-[#314C1C] text-md px-4 font-semibold">
            Focus on your breath for 1 minutes, inhaling deeply and exhaling
            slowly. Let go of distractions
            <br /> and center your mind.
          </p>
        </div>
        <div className="mx-auto my-auto mt-8 w-[600px] h-[255.738px] flex-shrink-0 rounded-lg border border-buttonsuccess bg-white shadow-md">
          <div className="flex flex-col items-center justify-center h-full">
            <div className="w-62 h-48 bg-[your-image-color] rounded-full">
              <img
                src="https://res.cloudinary.com/dddon9u5i/image/upload/v1701142845/undraw_Wandering_mind_re_x2a3_1_ge5h5y.png"
                alt="Animated human relaxing"
              />
            </div>
            <p className="mt-4 text-[#314C1C] text-lg font-semibold text-center">
              1 Minute Breathing Exercise
            </p>
          </div>
        </div>
        <div className="flex justify-center mt-4">
          <Link to="../relaxation29">
            <button className="w-400 h-12 px-32 flex items-center justify-center gap-4 flex-shrink-0 rounded-md bg-[#295700] text-white">
              Get Started
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Relaxation5;
